// import pluralize from 'pluralize';
import { HttpClient } from '@opallabs/api'
import reducePostPlacement from '../reducePostPlacement'

const putPostPlacement = ({ content_id, placement_id }) =>
  HttpClient().put(`/content/v2/${content_id}/placements/${placement_id}`, {
    params: {
      include: 'account,posts',
    },
  })

const updatePostPlacement = (options) => (dispatch) =>
  putPostPlacement(options)
    .then((response) => {
      const body = response.data

      if (body.data) {
        const { content_id, placement_id, prev_placement_id } = options

        dispatch(
          reducePostPlacement({
            content_id,
            placement_id,
            prev_placement_id,
          })
        )

        return true
      }

      return {}
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default updatePostPlacement
